import {hideModal, isEmpty, showModal} from "../utility";
import {getData, LOGIN, setData} from "../storage";

export const showMobileVerification = () => {
    let modal = document.getElementById("mobile-verification-modal")
    if (modal) {
        showModal(modal)
    }
}

export const hideMobileVerification = () => {
    let modal = document.getElementById("mobile-verification-modal");
    if (modal) {
        hideModal(modal)
    }

}

export const showPromocodeVerification = () => {
    let modal = document.getElementById("promotion-verification-modal")
    if (modal) {
        document.getElementById("myDropdown").click();
        showModal(modal)
    }
}

export const hidePromocodeVerification = () => {
    let modal = document.getElementById("promotion-verification-modal");
    if (modal) {
        hideModal(modal)
    }
}

export const checkIfUserRequestedToBecomeBroadcaster = (props) => {
    return (
        props.hasOwnProperty("broadcaster") &&
        props.broadcaster.hasOwnProperty("register") &&
        props.broadcaster.register.hasOwnProperty("payload") &&
        props.broadcaster.register.payload !== null
    )
}

export const checkIfRegisterBroadcaster = (props) => {
    return (
        props.hasOwnProperty("account_management") &&
        props.account_management.hasOwnProperty("userDetails") &&
        props.account_management.userDetails !== null &&
        props.account_management.userDetails.hasOwnProperty("broadcaster") &&
        Array.isArray(props.account_management.userDetails.broadcaster) &&
        props.account_management.userDetails.broadcaster.length > 0
    )
}

export const checkIfMobileNumberIsVerified = (props) => {
    return (
        props.hasOwnProperty("account_management") &&
        props.account_management.hasOwnProperty("userDetails") &&
        props.account_management.userDetails !== null &&
        props.account_management.userDetails.hasOwnProperty("broadcaster") &&
        Array.isArray(props.account_management.userDetails.broadcaster) &&
        props.account_management.userDetails.broadcaster.length > 0 &&
        props.account_management.userDetails.broadcaster[0].phone_number_validated === 1
    )
}

export const checkIfBroadcaster = (props) => {
    return (
        props.hasOwnProperty("account_management") &&
        props.account_management.hasOwnProperty("userDetails") &&
        props.account_management.userDetails !== null &&
        props.account_management.userDetails.hasOwnProperty("broadcaster") &&
        Array.isArray(props.account_management.userDetails.broadcaster) &&
        props.account_management.userDetails.broadcaster.length > 0 &&
        props.account_management.userDetails.broadcaster[0].is_verified === 0
    )
}

export const checkIfBroadcasterVerified = (props, broadcaster = []) => {
    if (broadcaster.length > 0) {
        return (
            broadcaster.length > 0 &&
            broadcaster[0].is_verified === 1
        )
    }

    return (
        props.hasOwnProperty("account_management") &&
        props.account_management.hasOwnProperty("userDetails") &&
        props.account_management.userDetails !== null &&
        props.account_management.userDetails.hasOwnProperty("broadcaster") &&
        Array.isArray(props.account_management.userDetails.broadcaster) &&
        props.account_management.userDetails.broadcaster.length > 0 &&
        props.account_management.userDetails.broadcaster[0].is_verified === 1
    )
}

export const checkIfVoucherAvailable = (props, broadcaster = []) => {
    if (broadcaster.length > 0) {
        return (
            broadcaster.length > 0 &&
            broadcaster[0].voucher.length> 0
        )
    }

    return (
        props.hasOwnProperty("account_management") &&
        props.account_management.hasOwnProperty("userDetails") &&
        props.account_management.userDetails !== null &&
        props.account_management.userDetails.hasOwnProperty("broadcaster") &&
        Array.isArray(props.account_management.userDetails.broadcaster) &&
        props.account_management.userDetails.broadcaster.length > 0 &&
        props.account_management.userDetails.broadcaster[0].voucher.length > 0
    )
}

export const checkForBroadcaster = (props,key) => {
    return (
        props.hasOwnProperty("broadcaster") &&
        props.broadcaster.hasOwnProperty(key) &&
        props.broadcaster[key].hasOwnProperty("payload") &&
        props.broadcaster[key].payload !== null
    )
}

export const registerAsBroadcaster = (callback)=>{

    getData(LOGIN)
        .then((data) => {
            if (!isEmpty(data)) {
                setData(LOGIN, {
                    ...data,
                    is_broadcaster: true
                }, () => {
                    if (callback !== null && typeof callback === "function") {
                        callback();
                    }
                });
            }
        })


}